import {Text} from '@primer/react'
import {AlertIcon} from '@primer/octicons-react'
import {TimelineRow} from './row/TimelineRow'

export function FallbackEvent(): JSX.Element {
  return (
    <TimelineRow
      showActorName={false}
      showAgoTimestamp={false}
      highlighted={false}
      actor={null}
      createdAt={''}
      deepLinkUrl={''}
      leadingIcon={AlertIcon}
    >
      <TimelineRow.Main>
        <Text>Could not load event</Text>
      </TimelineRow.Main>
    </TimelineRow>
  )
}

try{ FallbackEvent.displayName ||= 'FallbackEvent' } catch {}